// Initialize all .collapse__gallery-swiper Swipers
import Swiper from 'swiper';
import { Navigation, A11y, Keyboard } from 'swiper/modules';
import { a11y } from './config/a11y';

export function initSwiperTabsGallery() {
    const elements = document.querySelectorAll('.collapse__gallery-swiper');
    if (!elements.length) return null;

    const instances = [];

    elements.forEach((el) => {
        // Find navigation buttons in parent container
        const galleryContainer = el.closest('.collapse__gallery');
        const nextButton = galleryContainer ? galleryContainer.querySelector('.swiper-button-next') : null;
        const prevButton = galleryContainer ? galleryContainer.querySelector('.swiper-button-prev') : null;

        const instance = new Swiper(el, {
            modules: [Navigation, A11y, Keyboard],
            slidesPerView: 1,
            spaceBetween: 20,

            // Loop for continuous navigation
            loop: false,
            loopAdditionalSlides: 1,

            // Accessibility
            a11y,

            // Keyboard navigation (initially disabled)
            keyboard: {
                enabled: false,
                onlyInViewport: true
            },

            // Touch/Mouse behavior
            grabCursor: true,
            touchRatio: 1,
            touchAngle: 45,

            // Performance
            watchSlidesProgress: true,
            preloadImages: false,
            lazy: false, // Wird über WordPress-Lazy-Loading gehandelt

            // Dynamic height for different image sizes
            autoHeight: false, // Kann auf true gesetzt werden wenn Bilder unterschiedliche Höhen haben

            // Navigation
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
                disabledClass: 'swiper-button-disabled'
            },

            // Responsive breakpoints
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30
                }
            }
        });

        // Enable keyboard navigation only when swiper is focused or hovered
        const enableKeyboard = () => instance.keyboard.enable();
        const disableKeyboard = () => instance.keyboard.disable();

        el.addEventListener('mouseenter', enableKeyboard);
        el.addEventListener('mouseleave', disableKeyboard);
        el.addEventListener('focusin', enableKeyboard);
        el.addEventListener('focusout', disableKeyboard);

        instances.push(instance);

        // Toggle functionality for caption overlay with ARIA support
        const toggleButtons = el.querySelectorAll('.collapse__gallery-toggle');
        toggleButtons.forEach((toggleBtn) => {
            toggleBtn.addEventListener('click', function () {
                const slide = this.closest('.swiper-slide');
                const isActive = toggleBtn.classList.contains('is-active');

                if (isActive) {
                    // Close caption overlay
                    toggleBtn.classList.remove('is-active');
                    slide.classList.remove('overlay-visible');
                    toggleBtn.setAttribute('aria-expanded', 'false');
                } else {
                    // Open caption overlay
                    toggleBtn.classList.add('is-active');
                    slide.classList.add('overlay-visible');
                    toggleBtn.setAttribute('aria-expanded', 'true');
                }
            });
        });
    });

    return instances;
}
